module.exports = __webpack_public_path__ + "media/images/logo-0f27c0b268dcc64043504d113ce396ae.png";